import { useState } from 'react';
import { Field } from '@eti/form';
import { deriveCtaState, toPassValue } from '../utils/segmentSelection';
import SelectPassCta from './SelectPassCta';
import SelectionDrawer from './SelectionDrawer';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const FooterControl = ({
  input,
  config,
  labels,
  availableSegments,
  buildCartBreakdown,
  isMultiStop
}) => {
  var _committed$segments, _committed$segments2;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const committed = input.value;
  const saved = Boolean(committed === null || committed === void 0 ? void 0 : committed.saved);
  const segments = saved && committed !== null && committed !== void 0 && (_committed$segments = committed.segments) !== null && _committed$segments !== void 0 && _committed$segments.length ? committed.segments : availableSegments;
  const baseline = saved ? (_committed$segments2 = committed === null || committed === void 0 ? void 0 : committed.segments) !== null && _committed$segments2 !== void 0 ? _committed$segments2 : [] : [];
  const ctaState = deriveCtaState({
    saved,
    segments
  });
  const handleSave = next => {
    var _buildCartBreakdown;
    input.onChange(toPassValue(next, true, (_buildCartBreakdown = buildCartBreakdown === null || buildCartBreakdown === void 0 ? void 0 : buildCartBreakdown(next)) !== null && _buildCartBreakdown !== void 0 ? _buildCartBreakdown : null));
    setIsDrawerOpen(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectPassCta, {
      ctaState: ctaState,
      labels: labels,
      onOpen: () => setIsDrawerOpen(true)
    }), /*#__PURE__*/_jsx(SelectionDrawer, {
      committedSegments: baseline,
      config: config,
      initialSegments: segments,
      isMultiStop: isMultiStop,
      isOpen: isDrawerOpen,
      labels: labels,
      onClose: () => setIsDrawerOpen(false),
      onSave: handleSave
    })]
  });
};
const PickAndChooseFooter = ({
  config,
  labels,
  availableSegments,
  buildCartBreakdown,
  isMultiStop
}) => /*#__PURE__*/_jsx(Field, {
  availableSegments: availableSegments,
  buildCartBreakdown: buildCartBreakdown,
  component: FooterControl,
  config: config,
  isMultiStop: isMultiStop,
  labels: labels,
  name: `${config.product.name}.value`,
  useRHF: true
});
export default PickAndChooseFooter;
//# sourceMappingURL=PickAndChooseFooter.js.map